import {
  BarSeries,
  ChartComponent,
  ColumnSeries,
  DataLabel,
  DateTime,
  Inject,
  LineSeries,
  SeriesCollectionDirective,
  SeriesDirective,
  Zoom,
} from "@syncfusion/ej2-react-charts";
import React from "react";

// var CanvasJSChart = CanvasJSReact.CanvasJSChart;

const GraphAnalytics = ({ key, data, graphType, color }) => {
  return (
    <div className=" h-full">
      <ChartComponent
        primaryXAxis={{
          valueType: "DateTime",
          majorGridLines: { width: 0 },
          minorGridLines: { width: 0 },
          labelFormat: "MMM d",
          labelIntersectAction: "Hide",
          labelStyle: { size: "10px", color: "white" },
        }}
        primaryYAxis={{
          majorGridLines: { width: 0 },
          minorGridLines: { width: 0 },
          labelStyle: { size: "10px", color: "white" },
        }}
        className="dark:bg-black bg-analyticsCards"
        zoomSettings={{
          enablePan: true,
          enableSelectionZooming: true,
          mode: "X",
        }}
        id={key}
      >
        <Inject
          services={[
            LineSeries,
            DateTime,
            DataLabel,
            Zoom,
            BarSeries,
            ColumnSeries,
          ]}
        />
        <SeriesCollectionDirective>
          {data.map((x) => (
            <SeriesDirective
              dataSource={x}
              fill={color}
              xName="x"
              yName="y"
              width={2}
              type={graphType}
              marker={{
                dataLabel: {
                  visible: true,
                  font: { color: "white" },
                  format: "{value}",
                },
              }}
            ></SeriesDirective>
          ))}
        </SeriesCollectionDirective>
      </ChartComponent>
    </div>
  );
};

export default GraphAnalytics;
